'use client';
import clsx from 'clsx';
import { useEffect, useState } from 'react';

import { Button, ButtonProps } from './ui/button';

type ClickButtonProps = Readonly<{
  clickToDisable?: boolean;
  clickToProgress?: boolean;
  disabled?: boolean;
  progress?: boolean;
}> &
  ButtonProps;

export function ClickButton({
  clickToDisable,
  clickToProgress,
  disabled: incomingDisabled = false,
  progress: incomingProgress = false,
  ...props
}: ClickButtonProps) {
  const [disabled, setDisabled] = useState(false);
  const [progress, setProgress] = useState(false);

  return (
    <Button
      {...props}
      disabled={disabled || incomingDisabled}
      className={clsx(props.className, {
        'disabled:opacity-50': disabled,
        'progress-indefinite': progress || incomingProgress,
      })}
      onClick={(e) => {
        if (clickToDisable) {
          setTimeout(() => {
            setDisabled(true);
          });
        }

        if (clickToProgress) {
          setProgress(true);
        }

        props.onClick?.(e);
      }}
    />
  );
}
